import { useEffect, useMemo } from 'react';
import { useAccommodationsConsoleSearchParamsHelper } from '../useAccommodationsConsoleSearchParamsHelper';
import { SORT_QUERY_PARAM_KEY } from './constants';
import { useUpdateAccommodationsConsoleSearchParams } from './useUpdateAccommodationsConsoleSearchParams';
import { SortOption } from '@apps/accommodations/AccommodationsConsole.types';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useAccommodationsConsoleConfig } from '@apps/accommodations/AccommodationsConsoleConfigContext';

export const useListingsSortQueryParam = () => {
  const queryParamHelper = useAccommodationsConsoleSearchParamsHelper();
  const { applyAccommodationConsoleSearchParamsToUrl } = useUpdateAccommodationsConsoleSearchParams();
  const config = useAccommodationsConsoleConfig();
  const defaultSortOption = config.listingsPanel.sortConfig.defaultSortOption;

  // Set default sort in URL if not present
  useEffect(() => {
    if (!queryParamHelper.getValueString(SORT_QUERY_PARAM_KEY)) {
      applyAccommodationConsoleSearchParamsToUrl({
        searchParams: { [SORT_QUERY_PARAM_KEY]: defaultSortOption },
        actionType: 'replace',
      });
    }
  }, [queryParamHelper, applyAccommodationConsoleSearchParamsToUrl, defaultSortOption]);

  const currentSort: SortOption = useMemo(() => {
    return (queryParamHelper.getValueString(SORT_QUERY_PARAM_KEY) as Maybe<SortOption>) || defaultSortOption;
  }, [queryParamHelper, defaultSortOption]);

  const updateSort = useEventCallback((newSort: string | null) => {
    applyAccommodationConsoleSearchParamsToUrl({
      searchParams: {
        [SORT_QUERY_PARAM_KEY]: newSort,
      },
      actionType: 'push',
    });
  });

  return {
    currentSort,
    updateSort,
  };
};
